const BUTTON_STATE = {
  LOADING: "Saving...",
  SUCCESS: "Success!",
  ERROR: "Error - click to try again",
  NOTHING: "Save",
};

export default BUTTON_STATE;
